import { FC, useMemo } from "react";
import { useSelector } from "react-redux";
import { AppStore } from "../../../store";
import { AuthDTO } from "../../../store/auth/models/dto";
import {
  Fetchable,
  isFetchableSuccess,
} from "../../../store/common/fetchable/helpers";
import { VerificationDTO } from "../../../store/verification/models/dto/due-diligence";
import { VerificationService } from "../../../store/verification/service";
import { DueDiligenceConfigPage } from "../common/config-page";

export const NewDueDiligenceConfigPage: FC<{}> = () => {
  const login = useSelector<AppStore, Fetchable<AuthDTO.Responses.Login.T>>(
    (store) => store.auth.login
  );

  const defaults = useMemo(
    () => ({
      ...VerificationDTO.Requests.DueDiligence.Config.Post.defaults,
      ...(isFetchableSuccess(login)
        ? { merchantId: login.data.accessToken.credentialsId }
        : {}),
    }),
    [login]
  );

  return (
    <DueDiligenceConfigPage
      defaultValues={defaults}
      onSubmit={(data) => VerificationService.postNewDueDiligenceConfig(data)}
    >
      Create New
    </DueDiligenceConfigPage>
  );
};
